/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetActiveOrdersRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {GetActiveOrdersResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const getActiveOrders = (request: GetActiveOrdersRequest, options?: CashRequestOptions) => post<GetActiveOrdersRequest, GetActiveOrdersResponse>("/cash-app/local/orders/active", request, {...options, rejectOnError: true })